<div class="now-decorative-card now-decorative-card-small ps-4">
  <h3>{{ title }}</h3>
  <div>
    <div class="row">
      @if (!weiterbildungenLoading) {
        @for (weiterbildung of weiterbildungen; track weiterbildung.id) {
          <div class="col-12 col-md-4">
            <div class="now-radio-button-card themenfelder-card d-flex h-100">
              <input
                type="radio"
                name="radio-button-group"
                id="{{ weiterbildung.id }}"
                (change)="selectThemenFeld(weiterbildung)"
              />
              <label
                for="{{ weiterbildung.id }}"
                class="now-radio-button-card-default now-card text-break"
              >
                <span>{{ weiterbildung.kurzBezeichnungNeutral }}</span>
              </label>
            </div>
          </div>
        }
      } @else {
        <p>Daten werden geladen...</p>
      }
    </div>
    <div [ngClass]="{ 'row flex-row-reverse justify-content-between': !isMobile() }">
      <button
        [disabled]="weiterbildungenLoading || (!selectedThemenfeld && weiterbildungen.length !== 0)"
        (click)="emitSelection()"
        type="button"
        class="now-btn now-btn-primary w-auto"
        [ngClass]="{ 'w-auto': !isMobile() }"
      >
        Weiter
      </button>
      @if (!hideZurueckButton) {
        <button
          type="button"
          (click)="emitZurueckEvent()"
          class="now-btn now-btn-secondary"
          [ngClass]="{ 'w-auto mt-3': !isMobile(), 'mt-3': isMobile() }"
        >
          Zurück
        </button>
      }
    </div>
  </div>
</div>
